module.exports = __webpack_public_path__ + "static/img_4440-97556dcab897136a2edaccaa24073bc6.webp";